import React from 'react'
import Topsection from "./Topsection";
import Header from "./Header";
import Footer from "./Footer";
import FloatingButton from "./FloatingButton";

import { Helmet } from 'react-helmet';

const ProfanityPolicy = () => {
  return (
    <div>
          <Helmet>
                  <title>Fortune Cloud Technologies | Profanity Policy</title>
                  <meta name="description" content="Explore courses and training programs at Fortune Cloud Technologies. Learn with experts and get placed." />
                  <meta name="robots" content="index, follow" />
          </Helmet>
          <Topsection />
          <Header />
          <div className="courseslinear">
            <div className="container">
              <div className="row">
                <div className="col-md-12 col-12 mb-4">
    
                <div className="col align-start-center flex-wrap m-3">
                    <strong><h2 className="text-center text-dark myfont1 fw-bold">Profanity Policy</h2></strong>
                </div>
    
    
                  <div className="border p-4 p-md-5 rounded shadow-sm bg-white border border-3 d-flex">
    
                    <div className="text-dark fs-bold myfont1 text-justify fs-5">
    
                      <p>In all your interactions with FortuneCloud staff and employees, we solicit that they be treated with courtesy and respect. FortuneCloud is committed to a zero tolerance culture towards rude, inappropriate, threatening and abusive language or behavior.</p>

                      <p>Let’s all contribute to a positive and respectful learning environment.</p>
    
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
          <FloatingButton />
        </div>
  )
}

export default ProfanityPolicy